import React, { useState } from "react";
import { Button } from "components/Core/Button/Button";
import { Platform, View } from "react-native";
import { useTranslation } from "react-i18next";
import { useQuestionContext } from "lib/providers/questionProvider";
import { Input } from "components/Core/Input/Input";
import { FlexGrid, Message, Text, theme } from "@clearabee/ui-library-native";
import { useCatalogue } from "@clearabee/ui-sdk";
import { FormState } from "../SkipBags.validation";

export const Location = (): React.ReactElement => {
  const [translate] = useTranslation();
  const context = useQuestionContext<FormState>();
  const [readyToCollect, setReadyToCollect] = useState(
    context.get("readyToCollect"),
  );
  const { defaultCatalogue } = useCatalogue();
  const handballCharge = defaultCatalogue.items.find(
    (item) => item.sku === "HANDBALLCHARGE",
  );
  const isHeavy = context.get("bagContents")?.types.includes("tiles");

  return (
    <View style={{ alignItems: "center" }}>
      <Text
        color={Platform.OS === "web" ? "light" : "dark"}
        styles={{
          marginTop: theme.spacing.small,
          marginBottom: theme.spacing.medium,
        }}
      >
        {translate("hwa.screens.selectProduct.locationText")}
      </Text>
      <Input.Checkbox
        name="readyToCollect"
        inverted={Platform.OS === "web"}
        onChange={(value) => {
          setReadyToCollect(value);
        }}
        value={readyToCollect}
        labelFontSize="small"
        label={translate("hwa.screens.selectProduct.readyToCollect")}
      />

      <FlexGrid
        style={{
          minWidth: "80%",
          marginTop: theme.spacing.large,
        }}
        cellSpacing="xsmall"
        rowSpacing="xsmall"
        wrap="wrap"
      >
        <FlexGrid.Cell base="100%" medium="50%">
          <Button
            type="button"
            size="medium"
            color="warning"
            onClick={() =>
              context
                .set("readyToCollect", readyToCollect)
                .set("distanceFromRoad", "Within 4 metres", "open")
                .submit()
            }
          >
            {translate("hwa.screens.selectProduct.within4m")}
          </Button>
        </FlexGrid.Cell>
        <FlexGrid.Cell base="100%" medium="50%">
          <Button
            type="button"
            size="medium"
            color="warning"
            onClick={() =>
              context
                .set("readyToCollect", readyToCollect)
                .set("distanceFromRoad", "Between 4 and 10 metres", "open")
                .submit()
            }
          >
            {translate("hwa.screens.selectProduct.between4and10")}
          </Button>
        </FlexGrid.Cell>
      </FlexGrid>
      {isHeavy && (
        <Message
          styles={{
            alignSelf: "center",
            backgroundColor: theme.colors.negative.light,
          }}
          background
          invert
        >
          {translate("hwa.screens.selectProduct.handballCharge", {
            title: handballCharge?.title,
            price: handballCharge?.price,
          })}
        </Message>
      )}
    </View>
  );
};
